module.exports = __webpack_public_path__ + "static/media/food-3.50d620d7.jpg";